import {Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy} from "@angular/core";
@Pipe({
	name:'timeAgo'
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
	private timer: number;
	constructor(private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone) {}
	transform(value:string) {
		this.removeTimer();
		let d = new Date(value);
		let now = new Date();
		let seconds = Math.round((now.getTime() - d.getTime())/1000);
		let timeToUpdate = this.getSecondsUntilUpdate(seconds) *1000;
		this.timer = this.ngZone.runOutsideAngular(() => {
			if (typeof window !== 'undefined') {
				return window.setTimeout(() => {
					this.ngZone.run(() => this.changeDetectorRef.markForCheck());
				}, timeToUpdate);
			}
			return null;
		});

		let minutes = Math.round(Math.abs(seconds / 60));
		let hours = Math.round(Math.abs(minutes / 60));
		let days = Math.round(Math.abs(hours / 24));
		let months = Math.round(Math.abs(days/30.416));
		let years = Math.round(Math.abs(days/365));

		if(seconds>0) {
			if (seconds <= 45) {
				return 'a few seconds ago';
			} else if (seconds <= 90) {
				return 'a minute ago';
			} else if (minutes <= 45) {
				return minutes + ' minutes ago';
			} else if (minutes <= 90) {
				return 'an hour ago';
			} else if (hours <= 22) {
				return hours + ' hours ago';
			} else if (hours <= 36) {
				return 'yesterday';
			} else if (days >= 6 && days <=9) {
				return 'last week'
			} else if (days >= 12 && days <=16) {
				return '2 weeks ago'
			} else if (days >= 19 && days <=23) {
				return '3 weeks ago'
			} else if (days <= 25) {
				return days + ' days ago';
			} else if (days <= 45) {
				return 'a month ago';
			} else if (days <= 345) {
				return months + ' months ago';
			} else if (days <= 545) {
				return 'a year ago';
			} else { // (days > 545)
				return years + ' years ago';
			}
		}

		else {
			seconds = -seconds;

			if (seconds <=20 ) {
				return 'a few seconds ago';
			} else if (seconds <= 45) {
				return 'in a few seconds';
			} else if (seconds <= 90) {
				return 'in a minute';
			} else if (minutes <= 45) {
				return 'in ' + minutes + ' minutes';
			} else if (minutes <= 90) {
				return 'in an hour';
			} else if (hours <= 22) {
				return 'in ' + hours + ' hours';
			} else if (hours <= 36) {
				return 'tomorrow';
			} else if (days >= 6 && days <=9) {
				return 'next week'
			} else if (days >= 12 && days <=16) {
				return 'in 2 weeks'
			} else if (days >= 19 && days <=23) {
				return 'in 3 weeks'
			} else if (days <= 25) {
				return 'in ' + days + ' days';
			} else if (days <= 45) {
				return 'in a month';
			} else if (days <= 345) {
				return 'in ' + months + ' months';
			} else if (days <= 545) {
				return 'in a year';
			} else { // (days > 545)
				return 'in ' + years + ' years';
			}
		}
	}
	ngOnDestroy(): void {
		this.removeTimer();
	}
	private removeTimer() {
		if (this.timer) {
			window.clearTimeout(this.timer);
			this.timer = null;
		}
	}
	private getSecondsUntilUpdate(seconds:number) {
		let min = 60;
		let hr = min * 60;
		let day = hr * 24;
		if (seconds < min) { // less than 1 min, update ever 2 secs
			return 2;
		} else if (seconds < hr) { // less than an hour, update every 30 secs
			return 30;
		} else if (seconds < day) { // less then a day, update every 5 mins
			return 300;
		} else { // update every hour
			return 3600;
		}
	}
}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/pipes/time-ago.pipe.ts